module.exports = __webpack_public_path__ + "img/govpage_2.0eee8fcb.svg";